"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_provider = _interopRequireDefault(require("./_basic_provider"));
class ReportProblem extends _basic_provider.default {
  async postReportProblem(data) {
    return await this._callApi({
      method: 'post',
      path: `/report-problem`,
      payload: data,
      /*errorData : {data},*/errorName: 'ReportProblemError'
    });
  }
  async publishCard(data) {
    return await this._callApi({
      method: 'post',
      path: `/publish-card`,
      payload: data,
      /*errorData : {data},*/errorName: 'ReportProblemError'
    });
  }
}
var _default = ReportProblem;
exports.default = _default;